import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC } from 'react';
import Button from '../../button';
import useModal from '../../../hooks/use-modal.hook';
import Modal from '..';

export interface ConfirmModalProps {
  title?: string;
  content: string;
  onClose: (confirm?: boolean) => void;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({ title = 'Confirm', content, onClose }) => {
  const { closeModal } = useModal();

  const handleClose = (confirm?: boolean) => {
    onClose(confirm);
    closeModal();
  };

  return (
    <Modal>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button label="No, go back" type="cancel" onClick={() => handleClose(false)} />
        <Button onClick={() => handleClose(true)} label="Yes" />
      </DialogActions>
    </Modal>
  );
};

export default ConfirmModal;
